export default function TrustBanner() {
  return (
    <section className="py-16 bg-white border-y border-gray-200">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-12">
          <h3 className="text-2xl md:text-3xl font-bold text-black mb-2">
            Trusted by Leading Contractors Nationwide
          </h3>
          <p className="text-gray-600">Join hundreds of successful contractors who've transformed their businesses</p>
        </div>

        {/* Stats */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          <div className="text-center">
            <div className="text-4xl md:text-5xl font-bold text-red-500 mb-2">500+</div>
            <div className="text-gray-600 font-medium">Happy Clients</div>
          </div>
          <div className="text-center">
            <div className="text-4xl md:text-5xl font-bold text-red-500 mb-2">$50M+</div>
            <div className="text-gray-600 font-medium">Revenue Generated</div>
          </div>
          <div className="text-center">
            <div className="text-4xl md:text-5xl font-bold text-red-500 mb-2">250%</div>
            <div className="text-gray-600 font-medium">Avg. Lead Growth</div>
          </div>
          <div className="text-center">
            <div className="text-4xl md:text-5xl font-bold text-red-500 mb-2">4.9/5</div>
            <div className="text-gray-600 font-medium">Client Rating</div>
          </div>
        </div>
      </div>
    </section>
  );
}
